import { React, useEffect, useRef } from "react";
import Parallax from "parallax-js";

import "swiper/swiper-bundle.min.css";
import "./images.css";

import webWork1 from "../img/Elena_N.jpeg";
// import rotorImage from "../img/webdev-truck.png";
// import doctorImage from "../img/webdev-doctor.png";
// import myTabsImage from "../img/webdev-mytabs.png";
// import voiceImage from "../img/webdev-ai.png";

export default function WebDev() {
  const sceneRef = useRef(null);

  useEffect(() => {
    if (sceneRef.current) {
      const parallaxInstance = new Parallax(sceneRef.current, {
        relativeInput: true,
      });

      return () => parallaxInstance.destroy();
    }
  }, []);

  // const portfolioProjects = [
  //   {
  //     title: "Rotor Logistics",
  //     description: "Bilingual one-page logistics website with responsive layout and SEO tooling.",
  //     url: "https://rotor-logistics.com",
  //     preview: rotorImage,
  //   },
  //   {
  //     title: "K-Pediatrics & Internal Medicine",
  //     description: "Bilingual medical clinic SPA with AI chat assistant and SEO tooling.",
  //     url: "https://www.pediatricadultcare.com/",
  //     preview: doctorImage,
  //   },
  //   {
  //     title: "MyTabs",
  //     description: "Internal staff scheduling platform for hospital departments.",
  //     url: "https://mytabs.dev/",
  //     preview: myTabsImage,
  //   },
  //   {
  //     title: "Voice-to-ComfyUI",
  //     description: "AI tool that converts voice commands into ComfyUI workflows.",
  //     url: "https://voice-to-comfyui.vercel.app",
  //     preview: voiceImage,
  //   },
  // ];

  return (
    <div>
      <section className="overflow-hidden">
        <div className="container pt-2 pt-sm-4 pb-sm-2 pb-md-4 py-xl-5 mt-5">
          <div className="row align-items-center py-3 mt-md-1 my-lg-2 my-xl-2 my-xxl-3">
            <div className="col-lg-7 order-lg-2 d-flex justify-content-center justify-content-lg-end mb-4 mb-md-5 mb-lg-0 pb-3 pb-md-0">
              <div className="parallax me-lg-n4 me-xl-n5" style={{ maxWidth: "667px" }}>
                <div ref={sceneRef} className="container mt-4">
                  <div className="parallax-container position-relative" data-depth="0.1">
                    <img className="img-fluid custom-image shadow-lg" src={webWork1} alt="Елена Нуруллина" />
                  </div>
                  {/* <div className="parallax-layer stat-box" data-depth="-0.25">
                    <img src="assets/img/landing/business-consulting/hero/02.png" alt="Layer" />
                  </div> */}
                </div>
              </div>
            </div>

            <div className="col-lg-5 order-lg-0">
              <h2 className="display-6 text-center text-lg-start pb-sm-2 pb-md-3">Разработка сайтов</h2>
              <h2 className="lead text-center text-lg-start pb-xl-2 mx-auto mx-lg-0 mb-4" style={{ maxWidth: "620px" }}>
                Елена Нуруллина полностью самостоятельно разрабатывает сайты под ключ включая наш сайт «Форматы»:
                от структуры и дизайна до запуска, SEO и аналитики.
              </h2>
              <ul className="list-unstyled fs-lg text-center text-lg-start pb-1 mx-auto mx-lg-0 mb-3" style={{ maxWidth: "620px" }}>
                <p className="h4">Почему клиенты выбирают Елену:</p>
                <li className="mb-2">✔️ полный цикл разработки без посредников;</li>
                <li className="mb-2">✔️ сильный UX/UI и адаптивная верстка;</li>
                <li className="mb-2">✔️ технически чистая реализация и высокая скорость;</li>
                <li className="mb-2">✔️ SEO и аналитика с первого дня;</li>
                <li className="mb-2">✔️ фокус на заявках, доверии и росте конверсии.</li>
                <br />
                <p className="lead fs-xl text-center text-lg-start">
                  Реальные кейсы уже работают в бизнесе: логистика, медицина, внутренние системы и AI-продукты.
                </p>
                <br />
                <p className="lead fs-lg mb-2">
                  Форматы работ: лендинг / корпоративный сайт / каталог / персональный бренд / AI-интеграции.
                </p>
                {/* <p className="mb-lg-3 fw-semibold">
                  Портфолио: <a href="https://elenanurullina.vercel.app/" target="_blank" rel="noreferrer">elenanurullina.vercel.app</a>
                </p> */}
                <div className="d-flex flex-wrap gap-2 justify-content-center justify-content-lg-start">
                  <a className="btn btn-primary" href="https://elenanurullina.vercel.app/" target="_blank" rel="noreferrer">
                    Смотреть портфолио
                  </a>
                  <a className="btn btn-outline-primary" href="https://t.me/ElenkaSan">
                    Обсудить проект
                  </a>
                </div>
              </ul>
            </div>
          </div>
          <div className="container">
              <p className="m-1 position-relative text-center zindex-2 fw-bold h4"> Подробности уточняйте у администратора
              </p>
              <p className="fs-lg mb-2">Наши контакты:  
              <a className="btn btn-icon btn-lg btn-light btn-linkedin rounded-circle" href="https://vk.com/rubleva_coach"><i className="ai-vk"> </i> </a> 
              <a className="btn btn-icon btn-lg btn-light btn-linkedin rounded-circle" href="https://www.instagram.com/anyuta_rubleva"><i className="ai-instagram"> </i> </a> 
              <a className="btn btn-icon btn-lg btn-light btn-linkedin rounded-circle" href="https://t.me@AnnaRubleva_coach"><i className="ai-telegram"> </i> </a>
              <a className="nav-link fs-lg position-relative mb-2" href="mailto:developskillsnow@yandex.ru">Email: developskillsnow@yandex.ru</a>
             </p>
          </div>

          {/* <div className="container">
            <p className="m-1 position-relative text-center zindex-2 fw-bold h4">Карусель актуальных работ</p>
            <div id="webdevPortfolioCarousel" className="carousel slide mt-3" data-bs-ride="carousel">
              <div className="carousel-indicators">
                {portfolioProjects.map((_, index) => (
                  <button
                    key={`indicator-${index}`}
                    type="button"
                    data-bs-target="#webdevPortfolioCarousel"
                    data-bs-slide-to={index}
                    className={index === 0 ? "active" : ""}
                    aria-current={index === 0 ? "true" : undefined}
                    aria-label={`Слайд ${index + 1}`}
                  ></button>
                ))}
              </div>

              <div className="carousel-inner rounded-5 overflow-hidden">
                {portfolioProjects.map((project, index) => (
                  <div key={project.url} className={`carousel-item ${index === 0 ? "active" : ""}`}>
                    <img
                      src={project.preview}
                      className="d-block w-100"
                      alt={project.title}
                      style={{ maxHeight: "520px", objectFit: "cover" }}
                    />
                    <div className="carousel-caption d-block text-start rounded-4 p-3 p-md-4" style={{ backgroundColor: "rgba(0, 0, 0, 0.58)" }}>
                      <h3 className="h5 text-white mb-2">{project.title}</h3>
                      <p className="mb-3 text-white">{project.description}</p>
                      <a className="btn btn-sm btn-light" href={project.url} target="_blank" rel="noreferrer">
                        Открыть проект
                      </a>
                    </div>
                  </div>
                ))}
              </div>

              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#webdevPortfolioCarousel"
                data-bs-slide="prev"
                style={{ width: "48px", left: "-56px" }}
              >
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Предыдущий</span>
              </button>

              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#webdevPortfolioCarousel"
                data-bs-slide="next"
                style={{ width: "48px", right: "-56px" }}
              >
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Следующий</span>
              </button>
            </div>
          </div> */}

          <div className="d-lg-none mt-3 p-1">
            <p></p>
          </div>
        </div>
      </section>
    </div>
  );
}
